import React from 'react';
import { AnyField } from '../fields';

const HiddenInput = ({ field }: { field: AnyField }): JSX.Element => (
  <input
    hidden
    id={field.id}
    name={field.name}
    value={field.value?.toString()}
    onChange={() => {}}
    key={field.id}
  />
);

export default HiddenInput;
